const API_LINK = import.meta.env.VITE_API_LINK

export const LINKS = {
  AUTH: {
    CHECK_IF_EXIST_AND_GENERATE_PIN: () => `${API_LINK}/auth/check`,
    PIN: {
      CHECK_IF_EXIST: () => `${API_LINK}/auth/check-pin`,
      RESEND: () => `${API_LINK}/auth/resend-pin`
    },
    TOKEN: {
      CHECK_IF_EXIST: () => `${API_LINK}/auth/check-token`
    },
    REFRESH: () => `${API_LINK}/auth/refresh`,
    REFRESH_TOKEN: () => `${API_LINK}/auth/refresh-token`,
    LOGOUT: () => `${API_LINK}/auth/logout`
  },
  EVENT: {
    GET_ALL: () => `${API_LINK}/event/get-all`,
    CONFIRM: () => `${API_LINK}/event/confirm`,
    CANCEL: () => `${API_LINK}/event/cancel`
  },
  SUBSCRIPTION: {
    GET_ALL: () => `${API_LINK}/subscription/get-all`,
    TOGGLE_AUTO_RENEWAL: () => `${API_LINK}/subscription/toggle-auto-renewal`
  }
}
